/**
 * Rider Status API
 * 라이더 현황 페이지 관련 API
 */
import { apiClient } from '@/shared/api/client';
import { riderApi } from "@/features/rider/api/riderApi";
import type { RiderFilter, RiderApiItem } from "@/features/rider/riderStatus/types/riderStatus.types";

const BASE_PATH = '/api/v1/rider';

export const riderStatusApi = {

    getRiderList: riderApi.getRiderList,
    getSuppliers: riderApi.getSuppliers,

    /**
     * 라이더 검색 (필터 조건으로)
     * POST /api/v1/rider/status/search
     */
    searchRiders: async (filters: RiderFilter = {}): Promise<RiderApiItem[]> => {
        const response = await apiClient.post<RiderApiItem[]>(
            `${BASE_PATH}/status/search`,
            filters,
        );
        return response.data;
    },

    /**
     * 라이더 현황 엑셀 다운로드
     * Post /api/v1/rider/status/excel
     */
    downloadRiderStatusExcel: async (filters: RiderFilter = {}): Promise<Blob> => {
        const response = await apiClient.post<Blob>(`${BASE_PATH}/status/excel`, filters, {
            responseType: 'blob',
            timeout: 300000,
        });
        return response.data;
    },
};
